<template>
  <div class="content">
      <h2 class="content-heading">{{debt.debtor.fullname}}</h2>
      <div class="row justify-content-center">
        <div class="col-md-3">
          <div class="block block-rounded block-bordered">
            <ul class="nav nav-pills flex-column">
              <li class="nav-item">
                <a
                    class="nav-link d-flex align-items-center justify-content-between active"
                    id="info-tab"
                    data-toggle="pill"
                    href="#info-tab-content"
                    role="tab"
                    aria-controls="info-tab-content"
                    aria-selected="true"
                >
                  <span>{{ $t('app.main_information')}}</span>
                </a>
              </li>
              <li class="nav-item">
                <a
                    class="nav-link d-flex align-items-center justify-content-between"
                    id="contact-tab"
                    data-toggle="pill"
                    href="#contact-tab-content"
                    role="tab"
                    aria-controls="contact-tab-content"
                    aria-selected="false"
                    v-if="permissions.indexOf('access-any-contacts-debtor') != -1 || authUser.id === debt.user_id"
                >
                  <span>{{ $t('app.contact_information')}}</span>
                </a>
              </li>
              <li class="nav-item">
                <a
                    class="nav-link d-flex align-items-center justify-content-between"
                    id="payments-tab"
                    data-toggle="pill"
                    href="#payments-tab-content"
                    role="tab"
                    aria-controls="payments-tab-content"
                    aria-selected="false"
                >
                  <span>{{ $t('payments.index') }}</span>
                </a>
              </li>
              <li class="nav-item">
                <a
                    class="nav-link d-flex align-items-center justify-content-between"
                    id="history-tab"
                    data-toggle="pill"
                    href="#history-tab-content"
                    role="tab"
                    aria-controls="history-tab-content"
                    aria-selected="false"
                >
                  <span>{{ $t('transfer_histories.index') }}</span>
                </a>
              </li>
            </ul>
          </div>

          <debtor-debts v-if="debt.debtor_iin" />

        </div>

        <div class="col-md-9">
          <div class="tab-content" id="pills-tabContent">
            <div class="tab-pane fade fade-left show active" id="info-tab-content" role="tabpanel" aria-labelledby="info-tab">
              <debt-info/>
            </div>
            <div class="tab-pane fade fade-left" id="contact-tab-content" role="tabpanel" aria-labelledby="contact-tab">
              <debt-contacts v-if="permissions.indexOf('access-any-contacts-debtor') != -1 || authUser.id === debt.user_id" />
            </div>
            <div class="tab-pane fade fade-left" id="payments-tab-content" role="tabpanel" aria-labelledby="payments-tab">
              <debt-payments/>
            </div>
            <div class="tab-pane fade fade-left" id="history-tab-content" role="tabpanel" aria-labelledby="history-tab">
              <debt-transfers />
            </div>
          </div>
        </div>
      </div>

      <div class="row" v-if="permissions.indexOf('access-any-contacts-debtor') != -1 || authUser.id === debt.user_id">
        <div class="col">
          <div class="block block-rounded block-bordered">
              <div class="block-content">
                <div class="nav btn-group mb-2">
                  <a href="#prices" class="btn btn-secondary active" data-toggle="tab">
                    {{ $t('calls.index') }}
                  </a>
                  <a href="#features" class="btn btn-secondary" data-toggle="tab">
                    {{ $t('departures.index') }}
                  </a>
                </div>
                <div class="tab-content">
                  <div class="tab-pane fade fade-left show active" id="prices">
                    <debt-calls />
                  </div>
                  <div class="tab-pane fade fade-left" id="features">
                    <debt-departures />
                  </div>
                </div>
              </div>
          </div>
        </div>
      </div>

      <add-phone />
      <add-address />
      <add-call />
      <add-departure />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import DebtInfo from '@/components/employee/debt/Info.vue';

export default {
  name: 'debt-detail',
  data() {
    return {
      debtId: this.$route.params.id,
    };
  },
  mounted() {
    this.GET_DEBT_INFO(this.$route.params.id);
  },
  computed: {
    ...mapGetters([
      'debt',
      'permissions',
      'authUser',
    ]),
  },
  methods: {
    ...mapActions([
      'GET_DEBT_INFO',
    ]),
  },
  components: {
    DebtInfo,
    DebtorDebts: () => import('@/components/employee/debt/debtorDebts'),
    DebtContacts: () => import('@/components/employee/debt/contacts/index'),
    DebtPayments: () => import('@/components/employee/debt/payments/index'),
    DebtTransfers: () => import('@/components/employee/debt/transfers/index'),
    AddCall: () => import('@/components/employee/debt/calls/addCall'),
    AddDeparture: () => import('@/components/employee/debt/departures/addDeparture'),
    AddPhone: () => import('@/components/employee/debt/contacts/phones/addPhone'),
    AddAddress: () => import('@/components/employee/debt/contacts/addresses/addAddress'),
    DebtCalls: () => import('@/components/employee/debt/calls'),
    DebtDepartures: () => import('@/components/employee/debt/departures'),
  },
  watch: {
    '$route.params.id': function $routeParamsId() {
      this.GET_DEBT_INFO(this.$route.params.id);
    },
  },
};
</script>
